function setVar() {
    const headerMain = document.querySelector('.main-header');
    const headerHeight = headerMain ? headerMain.offsetHeight : 0;

    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    document.documentElement.style.setProperty('--headerHeight', `${headerHeight}px`);
}

function updateVar() {
    const headerMain = document.querySelector('.main-header');
    const headerHeight = headerMain ? headerMain.offsetHeight : 0;

    document.documentElement.style.setProperty('--headerHeight', `${headerHeight}px`);
}

export { setVar, updateVar };